import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import AtomButton from '../../atoms/button'
import AtomModal from '../../atoms/modal'
import emailjs from '@emailjs/browser';
import { meetingSchema, MeetingFormValues } from './schemas/meetingSchema'; 
import RHFTextField from '../../atoms/RHFComponents/RHFTextfield';
import RHFDateTimePicker from '../../atoms/RHFComponents/RHFDateTimepicker';

const events = [
  { value: 'HPCI', label: 'HPCI' },
  { value: 'PCHI', label: 'PCHI' },
  { value: 'Incosmetics Global', label: 'Incosmetics Global' },
  { value: 'NYSCC', label: 'NYSCC' },
  { value: 'Other', label: 'Other' },
];

const ScheduleMeetingForm = ({ open, toggleHandler }: { open: boolean; toggleHandler: () => void }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<MeetingFormValues>({
    resolver: zodResolver(meetingSchema),
    defaultValues: {
      name: '',
      company: '',
      phone_number: '',
      email_address: '',
      state: '',
      country: '',
      select_event: '',
      date_time:new Date(),
    },
  });

  const onSubmit = (data: MeetingFormValues) => {
     
    console.log('Submitted Data:', data);
    const form = document.createElement('form');
    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.name = key;
      input.value = value instanceof Date ? value.toISOString() : value || '';
      form.appendChild(input);
    });

    emailjs
      .sendForm(
        'service_lquhnld',  //service id
         'template_xx5cjp1', //template id
          form,
           'ElEBzWxD426nCfhUS'  //public key
        )
      .then(
        (result) => {
          console.log('Message Sent:', result.text);
          alert('Message sent successfully!');
          reset();
        },
        (error) => {
          console.error('Send Failed:', error.text);
          alert('Oops! Something went wrong.');
        }
      );
    reset();
    toggleHandler();
  };

  return (
    <AtomModal isOpen={open} onClose={toggleHandler} className="schedule-meeting">
      <h3>Schedule a meeting</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <RHFTextField
              name="name"
              label="Name"
              placeholder="Name*"
              control={control}
              error={!!errors.name}
              helperText={errors.name?.message}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <RHFTextField
              name="company"
              label="Company"
              placeholder="Company*"
              control={control}
              error={!!errors.company}
              helperText={errors.company?.message}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <RHFTextField
              name="phone_number"
              label="Phone Number"
              placeholder="Phone Number*"
              control={control}
              error={!!errors.phone_number}
              helperText={errors.phone_number?.message}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <RHFTextField
              name="email_address"
              label="Email Address"
              placeholder="Email Address*"
              control={control}
              error={!!errors.email_address}
              helperText={errors.email_address?.message}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <RHFTextField
              name="state"
              label="State"
              placeholder="State*"
              control={control}
              error={!!errors.state}
              helperText={errors.state?.message}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <RHFTextField
              name="country"
              label="Country"
              placeholder="Country*"
              control={control}
              error={!!errors.country}
              helperText={errors.country?.message}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <RHFDateTimePicker
              name="date_time"
              label="Meeting Date & Time"
              placeholder='Meeting Date & Time'
              control={control}
              error={!!errors.date_time}
              helperText={errors.date_time?.message}              
              required
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="select_event"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  displayEmpty
                  fullWidth
                  error={!!errors.select_event}
                  renderValue={(selected) =>
                    selected ? selected : <span className="placeholder">Select Event*</span>
                  }
                >
                  {events.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            {errors.select_event && (
              <p className="MuiFormHelperText-root Mui-error">{errors.select_event.message}</p>
            )}
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </AtomModal>
  );
};

export default ScheduleMeetingForm;
